<template>
  <section class="course-stages">
    <HiloStage
      v-for="(stage, i) in stages"
      :key="i"
      :stage="stage"
      :assignments="assignments"
      :index="i"
      :previousLength="previousLength(i)"
      @create-stage="createCurriculumStage"
      @duplicate-stage="duplicateStage"
      @create-assignment="createAssignment"
      @create-lesson="createLesson"
      @delete-confirmed="handleConfirmDelete"
      :is-student="isStudent"
    />

    <button
      v-if="!isStudent"
      class="add-stage"
      type="button"
      @click="toggleModal('stage')"
    >
      Add Stage <img src="/static/img/plus-white.svg" alt="" />
    </button>

    <BaseModal
      v-if="modal.isOpen && modal.type === 'assignment'"
      :isVisible="true"
      title="Add Assignment"
      @close="closeModal"
    >
      <template v-slot:default>
        <div class="input-wrapper">
          <label for="#">Assignment Type</label>
          <HiloSelect
            :theme="'grey'"
            v-model="assignmentId"
            :options="[{ id: 1, name: 'Create Assignment' }]"
            :placeholder="'Choose one...'"
            :customStyle="{
              backgroundColor: 'rgba(64, 64, 64, 0.05);',
              height: '50px',
              padding: '10px',
            }"
            size="sm"
          />
        </div>
        <button type="button" @click="createAssignment(modal.id)">
          Create
        </button>
      </template>
    </BaseModal>

    <BaseModal
      v-if="modal.isOpen && modal.type === 'stage'"
      :is-visible="true"
      title="Add Stage"
      @close="closeModal"
    >
      <template v-slot:default>
        <div class="input-wrapper">
          <label for="#select">Stage Title</label>
          <HiloSelect
            :theme="'grey'"
            v-model="stageIndex"
            :enableManualInput="true"
            :options="stageTitles"
            :placeholder="'Stage title'"
            :customStyle="{
              backgroundColor: 'rgba(64, 64, 64, 0.05);',
              height: '50px',
              padding: '10px',
            }"
            size="sm"
          />
        </div>
        <div class="input-wrapper input-wrapper-color">
          <label for="color">Stage Color</label>
          <div class="color-wrapper">
            <input name="color" type="color" v-model="color" />
          </div>
        </div>
        <button v-if="!isStudent" type="button" @click="createCurriculumStage">
          Add
        </button>
      </template>
    </BaseModal>
  </section>
</template>

<script>
import BaseModal from "../../../../Components/BaseModal.vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import CurriculumsAPIService from "../../../../../../servicehandlers/CurriculmsAPIService";
import AssignmentsAPIService from "../../../../../../servicehandlers/AssignmentsAPIService";
import LessonsAPIService from "../../../../../../servicehandlers/LessonsAPIService";
import HiloStage from "../../ClassroomComponents/HiloStage.vue";
import { useLoginStore } from "@/stores/loginStore";

const curriculumAPI = new CurriculumsAPIService();
const assignmentsAPI = new AssignmentsAPIService();
const lessonsAPI = new LessonsAPIService();

export default {
  components: { BaseModal, HiloSelect, HiloStage },
  props: {
    curriculumId: Number,
    stages: Array,
  },
  data() {
    return {
      isStudent: false,
      addAssignmentModal: false,
      addStage: false,
      stageIndex: null,
      lessonId: 0,
      subType: "",
      stageId: 0,
      assignmentId: 0,
      assignmentTitle: "",
      lessonTitle: "",
      lessonDescription: "",
      color: "",
      name: "",
      assignments: [],
      confirmModal: {
        type: "",
        id: null,
        isOpen: false,
      },
      modal: {
        type: null,
        isOpen: false,
        id: null,
      },
      subTypeOptions: [
        {
          id: 1,
          name: "Radio Comm Practice",
        },
        {
          id: 2,
          name: "Mock Checkride Prep",
        },
        {
          id: 3,
          name: "Knowledge Test Prep",
        },
      ],
      stageTitles: [],
    };
  },
  methods: {
    getStageTitles() {
      return curriculumAPI
        .getAllCurriculumStages(this.$router)
        .then((response) => {
          for (let title of response.map((data) => ({
            id: response.indexOf(data),
            name: data.name,
          }))) {
            if (!this.stageTitles.some((data) => data.name === title.name)) {
              this.stageTitles.push(title);
            }
          }
        });
    },
    async getAssignments() {
      this.assignments = await assignmentsAPI.getAllAssignments();
    },
    async createAssignment(lessonId) {
      this.$router.push({
        name: "Create Assignment",
        query: {
          lessonId: lessonId,
          createAssignment: true,
        },
      });
    },
    async createLesson(curriculumStageId) {
      this.$router.push({
        name: "Create Lesson",
        query: { curriculumStageId, curriculumId: this.curriculumId },
      });
    },
    async duplicateStage(id) {
      const stage = await curriculumAPI.duplicateCurriculumStage(id);
      this.$emit("on-update");
    },
    async createCurriculumStage() {
      try {
        const stage = await curriculumAPI.createCurriculumStage({
          name: this.stageTitles[this.stageIndex]?.name ?? this.stageIndex,
          curriculumId: this.curriculumId,
          color: this.color,
        });
        if (stage) {
          this.$emit("on-update");
          this.modal.isOpen = false;
        }
        this.stageIndex = null;
        this.color = "#000";
      } catch (error) {
        return error;
      }
    },
    async deleteLesson(lessonId) {
      try {
        await lessonsAPI.deleteLesson(lessonId);
      } catch (error) {
        return error;
      }
    },
    async deleteStage(stageId) {
      try {
        await curriculumAPI.deleteCurriculumStage(stageId);
        this.getStageTitles();
      } catch (error) {
        return error;
      }
    },
    toggleModal(type, id = null) {
      this.modal.type = type;
      this.modal.isOpen = true;
      this.modal.id = id;
    },
    closeModal() {
      this.modal.type = null;
      this.modal.isOpen = false;
      this.modal.id = null;
    },
    async handleConfirmDelete({ type, id }) {
      if (type === "lesson") {
        await this.deleteLesson(id);
      } else if (type === "stage") {
        await this.deleteStage(id);
      }
      this.$emit("on-update");
    },
    previousLength(i) {
      if (i === 0) {
        return 0;
      } else {
        let sum = 0;
        for (let y = i; y > 0; y--) {
          sum += this.stages[y - 1].lessons.length;
        }
        return sum;
      }
    },
  },
  mounted() {
    const loginStore = useLoginStore();
    this.getAssignments();
    this.isStudent =
      loginStore.getUser.userType.name === "Student" ||
      this.$route.query.studentId
        ? true
        : false;
    this.getStageTitles();
  },
};
</script>
<style lang="scss" scoped>
.add-stage {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 15px 0;
}

.hilo-modal-body {
  button {
    color: #fff;
    text-align: center;
    text-overflow: ellipsis;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
}

.input-wrapper {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;

  label {
    color: #404040;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .hilo-select {
    width: 460px;
  }

  input {
    width: 460px;
  }

  &-color {
    .color-wrapper {
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 10px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
    }

    input {
      width: 80px;
      height: 80px;
      background: transparent;
      padding: 0;
      flex: none;
    }
  }
}

.course-stages {
  width: 100%;
  overflow-x: auto;
  display: grid;
  gap: 50px;
}
</style>
